export default {"src":"/_next/static/media/sares-regis.899de836.svg","height":80,"width":180,"blurWidth":0,"blurHeight":0};